module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offer-slot"
  }, [_c('div', {
    staticClass: "offer-slot__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "offer-slot__description"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticClass: "offer-slot__details"
  }, [_c('div', {
    staticClass: "offer-slot__rules"
  }, [(_vm.offer.isEveryDay()) ? _c('div', {
    staticClass: "rules-day"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('offers_stage.every_day')))])]) : (_vm.offer.isWeekends()) ? _c('div', {
    staticClass: "rules-day"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('offers_stage.weekends')))])]) : (_vm.offer.isWeekdays()) ? _c('div', {
    staticClass: "rules-day"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('offers_stage.weekdays')))])]) : _vm._l((_vm.rules), function(rule) {
    return _c('div', {
      staticClass: "rules-day"
    }, [_c('span', [_vm._v(_vm._s(rule.day) + "s")])])
  })], 2), _vm._v(" "), (_vm.minPax || _vm.maxPax) ? _c('div', {
    staticClass: "offer-slot__people-requirement"
  }, [_c('div', [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 1792 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1536 1399q0 109-62.5 187t-150.5 78h-854q-88 0-150.5-78t-62.5-187q0-85 8.5-160.5t31.5-152 58.5-131 94-89 134.5-34.5q131 128 313 128t313-128q76 0 134.5 34.5t94 89 58.5 131 31.5 152 8.5 160.5zm-256-887q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"
    }
  })])]), _vm._v(" "), (_vm.minPax) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.$t('offers_stage.min')) + " "), _c('span', [_vm._v(_vm._s(_vm.minPax))])]) : _vm._e(), _vm._v(" "), (_vm.maxPax) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.$t('offers_stage.max')) + " "), _c('span', [_vm._v(_vm._s(_vm.maxPax))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.validFrom || _vm.validTo) ? _c('div', {
    staticClass: "offer-slot__validity"
  }, [(_vm.validFrom && _vm.offer.shouldShowValidFrom) ? _c('div', [_c('em', [_vm._v(_vm._s(_vm.$t('offers_stage.valid_from')))]), _vm._v(" " + _vm._s(_vm.validFrom) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.validTo) ? _c('div', [_c('em', [_vm._v(_vm._s(_vm.$t('offers_stage.valid_to')))]), _vm._v(" " + _vm._s(_vm.validTo) + "\n            ")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c552065","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offerSlot.vue
// module id = 595
// module chunks = 0